import gql from 'graphql-tag';

const financingAgProcessInfo = `
  id
  grower {
    id
    name
  }
`;

export const negotiationInformation = gql`
  query financingAgFinancing($agFinancingId: ID!) {
    financingAgFinancing(agFinancingId: $agFinancingId) {
      ${financingAgProcessInfo}
    }
  }
`;
